function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7066 2.60339C11.8863 2.46538 12.1364 2.46555 12.316 2.6038L20.305 8.7538C20.428 8.84845 20.5 8.99483 20.5 9.15V20.1C20.5 20.736 20.2482 21.3463 19.7995 21.7965C19.3507 22.2467 18.7417 22.5 18.1063 22.5H5.89368C5.2583 22.5 4.64928 22.2467 4.20051 21.7965C3.75179 21.3463 3.5 20.736 3.5 20.1V9.15C3.5 8.99459 3.57226 8.84802 3.69553 8.75339L11.7066 2.60339ZM9.84803 21.5H14.174V13.5H9.84803V21.5ZM15.174 21.5V13C15.174 12.7239 14.9502 12.5 14.674 12.5H9.34803C9.07189 12.5 8.84803 12.7239 8.84803 13V21.5H5.89368C5.52459 21.5 5.17028 21.3529 4.90879 21.0905C4.64724 20.8281 4.5 20.4718 4.5 20.1V9.3965L12.0106 3.63067L19.5 9.39609V20.1C19.5 20.4718 19.3528 20.8281 19.0912 21.0905C18.8297 21.3529 18.4754 21.5 18.1063 21.5H15.174Z",
  fill: "#383A35"
});

var SvgHomeIcon = function SvgHomeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-icon.8698ac7a.svg";
export { ForwardRef as ReactComponent };